import { Controller } from "@hotwired/stimulus"
import { swapText } from "../helpers/calendar_page_turn"

// The renewals strip's line (budgets/_renewals_strip). Every HOLD_MS the line
// under the title (bill and amount) turns to the next renewal.
// The strip itself is a link to the Review modal.
//
// Off screen nothing runs (IntersectionObserver). Reduced Motion swaps the
// text with no animation. The bill on screen is the index value, kept on the
// element, so a cached snapshot and its controller agree on it.
const HOLD_MS = 4200

export default class extends Controller {
  static targets = ["line", "amount"]
  static values = { items: Array, index: Number }

  connect() {
    this.reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (this.itemsValue.length < 2) return

    this.observer = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting
      this.visible ? this.schedule() : clearTimeout(this.timer)
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.visible = false
    this.observer?.disconnect()
    clearTimeout(this.timer)
  }

  schedule() {
    clearTimeout(this.timer)
    if (!this.visible) return
    this.timer = setTimeout(() => this.turn().then(() => this.schedule()), HOLD_MS)
  }

  async turn() {
    const next = (this.indexValue + 1) % this.itemsValue.length
    const item = this.itemsValue[next]
    this.indexValue = next

    if (this.reduce) return this.paintLine(item)
    await swapText([this.lineTarget, this.amountTarget], () => this.paintLine(item))
  }

  paintLine(item) {
    this.lineTarget.textContent = item.name
    this.amountTarget.textContent = item.amount_text
  }
}
